import React from 'react'
import { useMemo } from 'sb-hooks'
import { useIntl } from 'sb-react-intl'
import { Field, useFieldState } from 'formular'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import { Box } from 'components/_new/layout'
import { ContentLoader } from 'components/_new/ui'

import FrequencyOption from './FrequencyOption/FrequencyOption'

import messages from './messages'


type ChangeFrequencyModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  frequencies: ChangeFrequencyModal.Frequency[]
  frequencyField: Field<string>
  onConfirm: () => void
}

const ChangeFrequencyModalView: React.FunctionComponent<ChangeFrequencyModalViewProps> = (props) => {
  const { frequencies, frequencyField, onConfirm, onClose } = props
  const intl = useIntl()

  const text = useMemo(() => {
    if (!frequencies) {
      return null
    }

    // collect available periods to create a text
    const availablePeriods = []

    frequencies.forEach(({ shippingPeriod }) => {
      availablePeriods.push(shippingPeriod)
    })

    const period = availablePeriods.length === 2 ? ({
      ...messages.doublePeriod,
      values: {
        period1: availablePeriods[0],
        period2: availablePeriods[1],
      },
    }) : ({
      ...messages.singlePeriod,
      values: {
        period: availablePeriods[0],
      },
    })

    return {
      ...messages.text,
      values: {
        period: intl.formatMessage(period),
      },
    }
  }, [ frequencies, intl ])

  const { value: selectedFrequency } = useFieldState(frequencyField)

  return (
    <Modal
      className="humbleBgColor"
      title={messages.title}
      text={text}
      primaryButton={{
        title: messages.confirmButton,
        rightIcon: 'rightArrowSmall',
        disabled: !selectedFrequency,
        onClick: onConfirm,
      }}
      onClose={onClose}
    >
      <Box mt={24}>
        {
          Boolean(frequencies) ? (
            frequencies.map((item, index) => (
              <Box key={item.name} mt={index ? 16 : null}>
                <FrequencyOption data={item} field={frequencyField} />
              </Box>
            ))
          ) : (
            <ContentLoader />
          )
        }
      </Box>
    </Modal>
  )
}


export default ChangeFrequencyModalView
